module.exports = __webpack_public_path__ + "img/mapna-color.f2229d3.png";